import { Modal } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

export function I3PayFacFrame({ url, setCount, setTokenId, setPaymentMethod, setPluginLoading }) {
    const iframePlugin = useRef<HTMLIFrameElement>(null)
    const [openPlugin, setOpenPlugin] = useState<boolean>(true)

    useEffect(() => {
        setPluginLoading(true)
        window.addEventListener("message", eventListener)

        return () => {
            window.removeEventListener("message", () => {
                setTokenId("");
            })
        }
    }, [url])// eslint-disable-line react-hooks/exhaustive-deps

    const eventListener = (message) => {
        //if (message.origin !== "https://localhost:3000" || typeof message?.data !== "string") return
        if ((!message.origin.includes(".avr-cloud.com") && !message.origin.includes(".i3verticals.cloud")) || typeof message?.data !== "string") return

        if (message?.data === "pluginloaded") {
            setPluginLoading(false)
        }

        if (message?.data === "i3payfac_cancel") {
            window.removeEventListener("message", eventListener)
            setOpenPlugin(false)
            setPaymentMethod("")
        }

        if (message?.data.startsWith("token_id|")) {
            window.removeEventListener("message", eventListener)
            setPluginLoading(true)
            setTokenId(message?.data.split("|")[1])
            setCount(2)
        }
    }

    const preparePlugin = () => {
        const headScript = document.createElement("script")
        const bodyScript = document.createElement("script")
        headScript.src = url

        headScript.async = false
        iframePlugin.current?.contentWindow?.document.head.appendChild(headScript)

        headScript.onload = () => {
            bodyScript.text = ` 
                        i3Plugins.onPluginCreated = function (type, plugin) {
                        window.parent.postMessage('pluginloaded')
                        if (type == 'payment') {
                            plugin.onEmbed = function (msg) {
                                // Plugin is requesting the id of the element to embed
                                // the plugin in
                                return "divPlugin";
                            }
                            plugin.onCancel = function (msg) {
                                // Handle the user closing the plugin without paying
                                window.parent.postMessage('i3payfac_cancel')
                                this.hide(); // Call the plugin's hide function to hide it
                            }
                            plugin.onTokenize = function (msg) {
                                // Handle the token
                                window.parent.postMessage('token_id|' + msg["token_id"])
                                this.hide(); // Call the plugin's hide function to hide it
                            }
                        }
                    }
            `

            bodyScript.async = false
            iframePlugin.current?.contentWindow?.document.body.appendChild(bodyScript)
            setCount(1)
        }
    }

    let srcDoc = `
        <html>
            <head>
            </head>
            <body>
            </body>
        </html>
    `;

    return (
        <Modal open={openPlugin}>
            <div style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
                <iframe
                    style={{ border: "none", width: "100%", height: "100vh" }}
                    id="i3payfacframe"
                    title="i3payfac"
                    srcDoc={srcDoc}
                    ref={iframePlugin}
                    onLoad={preparePlugin}></iframe>
            </div>
        </Modal>
    )

}